import { loadLocationById } from '../../api/api'
import { call, select, put, take } from 'redux-saga/effects'
import { apiSaga } from './sagas'
import { normalizeLocationErrorResponse } from '../../util/errorUtils'
import { selectCurrentLocationWithAddress } from './selectors'

// ------------------------------------
// Action Types & Creators
// ------------------------------------

export const LOAD_LOCATION = 'foodsby/location/LOAD_LOCATION'
export const LOAD_LOCATION_SUCCESS = 'foodsby/location/LOAD_LOCATION_SUCCESS'
export const LOAD_LOCATION_FAILURE = 'foodsby/location/LOAD_LOCATION_FAILURE'
export const LOAD_PREVIOUS_LOCATION = 'foodsby/location/LOAD_PREVIOUS_LOCATION'
export const LOAD_PREVIOUS_LOCATION_SUCCESS =
  'foodsby/location/LOAD_PREVIOUS_LOCATION_SUCCESS'
export const LOAD_PREVIOUS_LOCATION_FAILURE =
  'foodsby/location/LOAD_PREVIOUS_LOCATION_FAILURE'

export const loadLocationStart = locationId => {
  return {
    type: LOAD_LOCATION,
    payload: { locationId }
  }
}

export const loadLocationSuccess = location => {
  return {
    type: LOAD_LOCATION_SUCCESS,
    payload: { location }
  }
}

export const loadLocationFailure = error => {
  return {
    type: LOAD_LOCATION_FAILURE,
    error
  }
}

export const loadPreviousLocationStart = locationId => {
  return {
    type: LOAD_PREVIOUS_LOCATION,
    payload: { locationId }
  }
}

export const loadPreviousLocationSuccess = previousLocation => {
  return {
    type: LOAD_PREVIOUS_LOCATION_SUCCESS,
    payload: { previousLocation }
  }
}

export const loadPreviousLocationFailure = error => {
  return {
    type: LOAD_PREVIOUS_LOCATION_FAILURE,
    error
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------

const ACTION_HANDLERS = {
  [LOAD_LOCATION]: state => {
    return {
      ...state,
      isLocationLoading: true
    }
  },
  [LOAD_LOCATION_SUCCESS]: (state, action) => {
    const {
      payload: { location }
    } = action
    return {
      ...state,
      isLocationLoading: false,
      location,
      locationError: undefined
    }
  },
  [LOAD_LOCATION_FAILURE]: (state, action) => {
    const error = normalizeLocationErrorResponse(action.error.response)
    return {
      ...state,
      isLocationLoading: false,
      location: undefined,
      locationError: error
    }
  },
  [LOAD_PREVIOUS_LOCATION]: state => {
    return {
      ...state,
      isLocationLoading: true
    }
  },
  [LOAD_PREVIOUS_LOCATION_SUCCESS]: (state, action) => {
    const {
      payload: { previousLocation }
    } = action
    previousLocation.address = {
      street: previousLocation.street,
      city: previousLocation.city,
      state: previousLocation.state,
      zip: previousLocation.zip
    }
    return {
      ...state,
      isLocationLoading: false,
      error: undefined,
      previousLocation
    }
  },
  [LOAD_PREVIOUS_LOCATION_FAILURE]: (state, action) => {
    const { error } = action
    return {
      ...state,
      isLocationLoading: false,
      previousLocation: undefined,
      error
    }
  }
}

// ------------------------------------
// Reducer
// ------------------------------------

const initialState = {
  isLocationLoading: false,
  location: undefined
}

export default function location(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

// ------------------------------------
// Sagas
// ------------------------------------

export function* watchLoadLocation() {
  while (true) {
    const {
      payload: { locationId }
    } = yield take(LOAD_LOCATION)
    const location = yield select(selectCurrentLocationWithAddress)
    if (!location || location.deliveryLocationId !== locationId) {
      yield call(
        apiSaga,
        loadLocationById,
        [locationId],
        loadLocationSuccess,
        loadLocationFailure,
        undefined
      )
    } else {
      yield put(loadLocationSuccess(location))
    }
  }
}
export function* watchLoadPreviousLocation() {
  while (true) {
    const {
      payload: { locationId }
    } = yield take(LOAD_PREVIOUS_LOCATION)
    yield call(
      apiSaga,
      loadLocationById,
      [locationId],
      loadPreviousLocationSuccess,
      loadPreviousLocationFailure,
      undefined,
      true
    )
  }
}
